import * as vp from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './AvailableBalance.module.scss';

type AvailableBalanceProps = {
  availableBalance: string;
  currency?: vp.SupportedCurrencies;
};

const AvailableBalance: React.FC<AvailableBalanceProps> = ({ availableBalance, currency = 'CAD' }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'AvailableBalance' });

  return (
    <div className={styles.balanceView}>
      <div className={styles.balanceHeader}>{t('title', { defaultValue: 'Available Balance' })}</div>
      <div className={styles.balanceValue}>
        {currency} {vp.formattedCurrency(availableBalance)}
      </div>
    </div>
  );
};

export default AvailableBalance;
